import StudioModal from '@/components/modals/StudioModal.vue';
import { Component } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button } from 'streamlabs-beaker';
import EditorBase from '../EditorBase';
import { Spinner, EmptySection } from 'streamlabs-beaker';
import { Debounce } from 'lodash-decorators';
import { EComponentType } from '@/helpers/editor';

@Component({
  components: {
    StudioModal,
    SButton: Button,
    SSpinner: Spinner,
    SEmptySection: EmptySection,
  },
})
export default class StreamLabelModal extends EditorBase {
  filteredStreamLabelData = null;
  filter: string = null;
  filterFocused: boolean = false;
  isSearching: boolean = false;
  selectedStreamLabel: string = null;

  get modalName(): string {
    return EModalName.streamLabel;
  }

  get hasResult(): boolean {
    return Object.values(this.groupedStreamLabels).some((val: []) => val.length);
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  get groupedStreamLabels() {
    if (!this.streamLabelData) return {};

    const groups = {
      donation: [],
      donator: [],
      subscriber: [],
      follower: [],
      others: [],
    };

    Object.keys(this.filteredStreamLabelData || this.streamLabelData).forEach((key) => {
      switch (true) {
        case key.includes('facebook'):
        case key.includes('cheerer'):
        case key.includes('gifter'):
        case key.includes('superchat'):
          break;
        case key.includes('donation'):
          groups.donation.push({ key, data: this.streamLabelData[key] });
          break;
        case key.includes('donator'):
          groups.donator.push({ key, data: this.streamLabelData[key] });
          break;
        case key.includes('subscriber'):
          groups.subscriber.push({ key, data: this.streamLabelData[key] });
          break;
        case key.includes('follower'):
          groups.follower.push({ key, data: this.streamLabelData[key] });
          break;
        default:
          groups.others.push({ key, data: this.streamLabelData[key] });
      }
    });

    return groups;
  }


  onFilterFocused() {
    this.filterFocused = true;
  }

  onFilterBlurred() {
    this.filterFocused = false;
  }

  onFilterKeyDown() {
    if (!this.filter) {
      this.isSearching = false;
      this.filteredStreamLabelData = null;
      return;
    }

    this.isSearching = true;

    this.formatFilteredStreamLabelData();
  }

  @Debounce(200)
  formatFilteredStreamLabelData() {
    const result = {};

    Object.keys(this.streamLabelData).forEach((key) => {
      // replace underscore and space to ''
      if (key.replace(/[_\s]/g, '').includes(this.filter.toLowerCase().replace(/[_\s]/g, '')))
        result[key] = this.streamLabelData[key];
    });

    this.filteredStreamLabelData = result;
    this.isSearching = false;
  }

  addLabel(label) {
    this.selectedStreamLabel = label;
  }

  modalOnClosed() {
    this.filter = null;
    this.filterFocused = false;
    this.filteredStreamLabelData = null;
  }

  applySelectedStreamLabel() {
    if (this.selectedComponent.type !== EComponentType.streamLabel) return;

    const value = `${this.selectedComponent.value} {${this.selectedStreamLabel}}`;
    this.onComponentUpdate({ id: this.selectedComponent.id, value });
    this.hideModal();
  }
}
